import { Button } from "primereact/button";
import { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectDefects } from "../../store/selectors/defectSelectors";
import { selectPositiveItems } from "../../store/selectors/positiveItemSelectors";
import { selectInspectionData, selectInspectionIsDisabled } from "../../store/selectors/inspectionSelectors";
import { setShowGeneratedItemsDialog } from "../../store/slices/inspectionSlice";

export const GenerateItemsButton = () => {
    const dispatch = useAppDispatch();
    
    const inspection = useAppSelector(selectInspectionData);
    const defects = useAppSelector(selectDefects);
    const positiveItems = useAppSelector(selectPositiveItems);
    const inspectionDisabled = useAppSelector(selectInspectionIsDisabled);

    const disabled = useMemo(() => (
        inspectionDisabled
    ), [inspection, defects, positiveItems]);

    const onGenerate = useCallback(() => {
        dispatch(setShowGeneratedItemsDialog(true));
    }, [inspection]);

    return (
        <Button label="Generate Notable Items" className="ml-3" onClick={onGenerate} disabled={disabled} data-cy="generate-items-button"/>
    );
}